import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/agent/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left side configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Seguridad Cambios'), // Localized label
                            width: 150,
                        },
                    ],
                },
                Table, // Table component for displaying data
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Permission check for displaying the view
        if (!devConfig.getPermAction('AgentConfigurationSecurityChangesMenu', 'Menu')) {
            this.show('./agent.configuration.qrgoogle'); // Redirect if permission is denied
        } else {
            return {
                type: 'clean',
                view: 'form', // Form view for the main layout
                scroll: true,
                cols: [left], // Left column configuration
            };
        }
    }
}

// FILE DOCUMENTED
